import { PeriodStatus } from './types';
import { AccountingPeriodStatus } from '@/api/REST/accountingPeriods';

export function formatISOtoDisplay(iso: string): string {
  // expects yyyy-MM-dd → dd/MM/yyyy
  const [y, m, d] = iso.split('-');
  return `${d}/${m}/${y}`;
}

export function sortBy<T>(
  items: T[],
  getter: (t: T) => string | number,
  dir: 'asc' | 'desc',
): T[] {
  return [...items].sort((a, b) => {
    const va = getter(a);
    const vb = getter(b);
    if (va < vb) return dir === 'asc' ? -1 : 1;
    if (va > vb) return dir === 'asc' ? 1 : -1;
    return 0;
  });
}

export function statusColor(
  status: PeriodStatus,
): 'default' | 'success' | 'warning' | 'error' | 'info' {
  switch (status) {
    case 'Open':
      return 'success';
    case 'Closed for registration':
      return 'warning';
    case 'Closed for invoicing':
      return 'error';
    case 'Closed':
    default:
      return 'info';
  }
}

export function generatePeriodId(startDate: string): string {
  return startDate.substring(0, 7); // yyyy-MM
}

// Display status mapping
export const getStatusDisplayValue = (
  status: AccountingPeriodStatus,
): string => {
  switch (status) {
    case AccountingPeriodStatus.Open:
      return 'Open';
    case AccountingPeriodStatus.ClosedForRegistration:
      return 'Closed for registration';
    case AccountingPeriodStatus.ClosedForRegistrationAndInvoicing:
      return 'Closed for invoicing';
    case AccountingPeriodStatus.Closed:
      return 'Closed';
    default:
      return 'Unknown';
  }
};
